import React, { FC } from "react";
import { Icon, IconProps } from "../Icon";

export const Minus: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path  fill="currentColor" d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm3 11H9a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2Z"/>
  </Icon>
);